export default class extends Controller {
  connect() {
    App.Helpers.listenToCustomEvent(
      document,
      this.focusEventName,
      (function(event) { this.conditionallyDo(event, this.enlarge.bind(this)) }).bind(this)
    )
    App.Helpers.listenToCustomEvent(
      document,
      this.unfocusEventName,
      (function(event) { this.conditionallyDo(event, this.shrink.bind(this)) }).bind(this)
    )
  }

  conditionallyDo(event, handler) {
    const { color } = event.detail
    if (color === this.color) {
      handler(event)
    }
  }

  enlarge() {}

  shrink() {}

  get color() {
    return this.data.get("color")
  }

  get focusEventName() {
    return "colorized-category:focus"
  }

  get unfocusEventName() {
    return "colorized-category:unfocus"
  }
}



// WEBPACK FOOTER //
// ./app/components/data_displays/assets/javascript/data-displays-colorized-categorizable-controller.js